const csCenterRoutes = [
  {
    path: "/support",
    name: "Support",
    meta: {
      menuIndex: 5,
      gtm: "고객센터"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/Support.vue")
  },
  {
    path: "/cscenter/passsafeguard/contract",
    name: "PassSafeguardContract",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>세이프가드 가입페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/passsafeguard/Contract.vue")
  },
  {
    path: "/cscenter/passsafeguard/cert",
    name: "PassSafeGuardCert",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>세이프가드 인증 번호 입력 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/passsafeguard/Cert.vue")
  },
  {
    path: "/cscenter/passsafeguard/id-verify",
    name: "PassSafeguardIdVerify",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>LG 세이프가드 NICE 연동 입력 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/passsafeguard/IdVerify.vue")
  },
  {
    path: "/cscenter/passsafeguard/id-verify-cert",
    name: "PassSafeGuardIdVerifyCert",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>LG 세이프가드 NICE 연동 인증 번호 입력 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/passsafeguard/IdVerifyCert.vue")
  },
  {
    path: "/cscenter/passsafeguard/result",
    name: "PassSafeGuardResult",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>세이프가드 가입 결과 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/passsafeguard/Result.vue")
  },
  {
    path: "/cscenter/passsafeguard/termination",
    name: "PassSafeguardTermination",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>세이프가드 해지 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/passsafeguard/Termination.vue")
  },
  {
    path: "/cscenter/passsafeguard/compensation",
    name: "PassSafeguardCompensation",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>세이프가드 보상신청 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/passsafeguard/Compensation.vue")
  },
  {
    path: "/cscenter/safebilling/contract",
    name: "SafebillingContract",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>세이프빌링 가입 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/safebilling/Contract.vue")
  },
  {
    path: "/cscenter/safebilling/refund",
    name: "SafebillingRefund",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>세이프빌링 환불 신청 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/safebilling/Refund.vue")
  },
  {
    path: "/cscenter/safebilling/cert",
    name: "SafebillingCert",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>세이프빌링 인증 번호 입력 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/safebilling/Cert.vue")
  },
  {
    path: "/cscenter/safebilling/result",
    name: "SafebillingResult",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>세이프빌링 결과 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/safebilling/Result.vue")
  },
  {
    path: "/cscenter/safebilling/compensation",
    name: "SafebillingCompensation",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>세이프빌링 보상 신청 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/safebilling/Compensation.vue")
  },
  // safe billing eos
  // {
  //   path: "/cscenter/safebilling/termination",
  //   name: "SafebillingTermination",
  //   meta: {
  //     menuIndex: 5
  //   },
  //   component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/safebilling/Termination.vue")
  // },
  {
    path: "/cscenter/passprime/contract",
    name: "PassPrimeContract",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>PASS프라임 가입 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/passprime/Contract.vue")
  },
  {
    path: "/cscenter/passprime/cert",
    name: "PassPrimeCert",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>PASS프라임 가입 인증 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/passprime/Cert.vue")
  },
  {
    path: "/cscenter/passprime/result",
    name: "PassPrimeResult",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>PASS프라임 결과"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/passprime/Result.vue")
  },
  {
    path: "/cscenter/passprime/termination",
    name: "PassPrimeTermination",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>PASS프라임 해지 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/passprime/Termination.vue")
  },
  {
    path: "/prime/skt/term",
    name: "PassPrimeSmsTermination",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>PASS프라임 외부 해지 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/passprime/Termination.vue")
  },
  {
    path: "/cscenter/safeid/termination",
    name: "SafeidTermination",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>정보유출안심케어 해지 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/safeid/Termination.vue")
  },
  {
    path: "/cscenter/safeid/cert",
    name: "SafeidCert",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>정보유출안심케어 인증번호 입력 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/safeid/Cert.vue")
  },
  {
    path: "/cscenter/safeid/result",
    name: "SafeidResult",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>정보유출안심케어 결과 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/safeid/Result.vue")
  },
  {
    path: "/cscenter/refund",
    name: "Refund",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>환불 신청 페이지"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/refund/Refund.vue")
  },
  {
    path: "/cscenter/refund/result",
    name: "RefundResult",
    meta: {
      menuIndex: 5,
      gtm: "고객센터>환불 신청 결과"
    },
    component: () => import(/* webpackChunkName: "cscenter" */ "@/pages/cscenter/refund/Result.vue")
  },
];
export default csCenterRoutes;
